import styled from '@emotion/styled'

export const SocialMediaContainerStyled = styled.div`
margin-top: 20px;
.Icon__SocialMedia {
  margin-right: 25px;
  cursor: pointer;
}

`